import { render, staticRenderFns } from "./objCurveSelected.vue?vue&type=template&id=1da356f0&"
import script from "./objCurveSelected.vue?vue&type=script&lang=ts&"
export * from "./objCurveSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports